// extracted by mini-css-extract-plugin
module.exports = {"title":"SectionFeaturedReviews_title__jylyp","carousel":"SectionFeaturedReviews_carousel__1Lfmd","step":"SectionFeaturedReviews_step__3NGX_"};